import { defineComponent as _defineComponent } from 'vue'
import { ref, defineAsyncComponent, computed } from 'vue'
import { useSubmit } from './FormMixin'
import { PHONE_WAY } from '@/const'
import useField from '@/composables/useField'
import useGlobal from '@/composables/useGlobal'
import { usePromise } from '@/composables/usePromise'
import { useModalOpener } from '@/composables/useModalOpener'
import { passwordResetRequestResource, passwordSetNewResource } from '@/services/auth.service'
import { useSuccessToast } from '@/composables/useToast'
import { useConfirmDialog } from '@/composables/useConfirm'

const phoneMask = "+38 (0##) ### ## ##"

export default /*@__PURE__*/_defineComponent({
  __name: 'PasswordReset',
  props: {
  info: String,
  close: Function,
  isModal: {
    type: Boolean,
    default: true
  }
},
  emits: ['changeForm'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const AuthModal = defineAsyncComponent(() => import('@/components/forms/AuthForm.vue'))
const TokenConfirmationCheck = defineAsyncComponent(() => import('@app/token/ConfirmationCheck.vue'))
const PasswordSetForm = defineAsyncComponent(() => import('@/components/forms/PasswordSetForm.vue'))

const props = __props

const formData = ref({
  token: props?.info || ''
})
const keyForReloading = ref(Date.now())
const formRef = ref(null)
const emit = __emit
const { $t } = useGlobal()
const load = ref(false)
const nonFieldErrors = ref("")
const way = PHONE_WAY;

const fields = ref([
  useField('token', $t('Phone number'), {
    rules: 'required|min:2|max:70',
    mask: phoneMask,
  }),
  useField('newPassword1', $t('New password'), {
    rules: 'required|min:8|max:128',
    type: 'password',
  }),
  useField('password2', $t('Confirm password'), {
    name: 'newPassword2',
    label: $t('Confirm password'),
    rules: 'required|confirmed:@newPassword1',
    // rules:`required|min:8|max:128`,
    type: 'password',
  }),
])

const toAuthForm = () => {
  emit('changeForm', true)
}

const validateForm = async (f, action, setErrors) => {
  const { valid } = (await f())
  console.log(valid, ">>>>");
  if (valid) {
    try {
      await action(true)
      keyForReloading.value = Date.now()
    } catch (e) {
      console.warn(e);
    }
  }
}

const request = (sendData, control) => {
  useSubmit(send( sendData, control), control)
}

const openPasswordSetModal = (token) => {
    const toPromise = value => usePromise(value)
      .then(a => {
        console.log("IS SENDED!!!", a);
      })
      .catch((e) => {
        console.log('canceled', e);
      })
  const { open, close } = useModalOpener({
    component: PasswordSetForm,
    clickToClose: true,
    initial: {
      token
    },
    promise: toPromise,
  })
  open()
}

const send = async (sendData: any, control: any) => {
  const preparedData = {
    tokenId: sendData,
    ...formData.value
  }
  const question = $t('Are you sure you want to set this password?')
  const successMessage = $t('Your password has been changed successfully.')
  try {
      await useConfirmDialog({question})
      load.value = true
      preparedData.token = preparedData.token.replace(/\D/g, '')
      const { data: { item: { tokenId } } } = await passwordSetNewResource.execute({}, {
        ...preparedData
      })
      useSuccessToast(successMessage)
      // props.close()
      // openPasswordSetModal(tokenId)
      toAuthForm()
      // window.location.href = redirectTo
  } catch (e) {
    load.value = false
    return Promise.reject(e)
  }
}



const __returned__ = { AuthModal, TokenConfirmationCheck, PasswordSetForm, props, formData, keyForReloading, formRef, emit, $t, load, nonFieldErrors, phoneMask, way, fields, toAuthForm, validateForm, request, openPasswordSetModal, send, ref, defineAsyncComponent, computed, get useSubmit() { return useSubmit }, get PHONE_WAY() { return PHONE_WAY }, get useField() { return useField }, get useGlobal() { return useGlobal }, get usePromise() { return usePromise }, get useModalOpener() { return useModalOpener }, get passwordResetRequestResource() { return passwordResetRequestResource }, get passwordSetNewResource() { return passwordSetNewResource }, get useSuccessToast() { return useSuccessToast }, get useConfirmDialog() { return useConfirmDialog } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})